import hyperdom from 'hyperdom'
import PaymentGateway from './paymentGateway.jsx'
import formatPrice from '../../../../packages/ui-helpers/formatPrice.js'

export default class PaymentGatewayFull extends PaymentGateway {
  eligible () {
    return !!this.payment.booking.booking.paymentOptions.full
  }

  amount () {
    return this.payment.booking.booking.paymentOptions.full.amount
  }

  paymentOptionName () {
    return 'Pay in full'
  }

  isPriceDiscount () {
    return this.payment.totalBeforeDiscount().amount - this.payment.booking.booking.paymentOptions.full.amount > 0
  }

  renderDiscountRibbon () {
    const discount = this.payment.totalBeforeDiscount().amount - this.payment.booking.booking.paymentOptions.full.amount
    return discount > 0 ? <span className='ribbon -right payment-option__ribbon'>Save
      {' '+formatPrice({
        amount: discount,
        currency: this.payment.departure.prices.currency,
      })}</span> : ''
  }

  renderPrice () {
    return <div className='payment-option__price'>
      <div className='payment-option__price-val'>{formatPrice({
        currency: this.payment.departure.prices.currency,
        amount: this.payment.booking.booking.paymentOptions.full.amount,
      })}</div>
      {this.isPriceDiscount() ? <div className='payment-option__green-desc'>Save 10% for paying in full</div> : ''}
    </div>
  }
}

